import { Button, IconButton, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import get from "lodash/get";
import React from "react";
import { useRecordContext, useTranslate } from "react-admin";
import { useCopyFeedback } from "./useCopyFeedback";

const useStyles = makeStyles({
	button: {
		fontSize: "inherit",
	},
	wrapper: {
		display: "inline-flex",
		alignItems: "center",
		gap: 8,
	},
});

const CopyIconButton = ({ onClick, children }) => (
	<IconButton size="small" style={{ padding: 4 }} onClick={onClick}>
		<FileCopyIcon style={{ fontSize: 16 }} />
		{children}
	</IconButton>
);

const CopySimpleButton = ({ onClick, children }) => {
	const classes = useStyles();
	return (
		<Button classes={{ root: classes.button }} onClick={onClick}>
			{children}
		</Button>
	);
};

const VARIANT_COMPONENTS = {
	icon: CopyIconButton,
	button: CopySimpleButton,
};

export const CopyField = ({
	source,
	value,
	children,
	variant = "icon",
	copyByIcon = false,
	iconPosition = "left",
}) => {
	const classes = useStyles();
	const translate = useTranslate();
	const record = useRecordContext();
	const { copied, copy } = useCopyFeedback();
	const text = value ?? get(record, source);

	if (!text && !children) return null;

	const content = children ?? text;
	const ButtonComponent = VARIANT_COMPONENTS[variant];

	if (!ButtonComponent) {
		throw new Error(`CopyField: unknown variant "${variant}"`);
	}

	const handleCopy = (e) => {
		e.stopPropagation();
		copy(text);
	};

	const contentInButton = !copyByIcon ? content : null;
	const contentOutside = copyByIcon ? content : null;

	const tooltipTitle = copied
		? translate("osfc.buttons.copy.success")
		: translate("osfc.buttons.copy.title");

	const iconButton = (
		<Tooltip title={tooltipTitle}>
			<ButtonComponent onClick={handleCopy}>{contentInButton}</ButtonComponent>
		</Tooltip>
	);

	return (
		<span className={classes.wrapper}>
			{iconPosition === "left" ? iconButton : contentOutside}
			{iconPosition === "left" ? contentOutside : iconButton}
		</span>
	);
};

CopyField.defaultProps = {
	addLabel: true,
};
